import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Recurring extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Recurring";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      template_id: null,
      name: null,
      description: null,

      payment_type: 'AUTOPAY',

      detail: {
        id_invoice: null,
        id_order: null,
        id_po: null,
        id_external: null,
      },

      status: 'PENDING',

      actions: {
        require_token_authorization: false,
      },

      start_date: new Date(),
      end_date: null,

      schedule: {
        strict: false,
        interval: null,
        dom: null,
        periods: 1,
        cycles: 1,
        start_date: new Date(),
        end_date: null,
        renew_plan: false,
        renewal_days: 0,
        dates: []
      },

      invoice: {
        payment_reminder_days: 0,
        late_notification_days: 0,
        enable_autopay: true,
        send_welcome: true,
        send_late: true,
        send_overdue: true,
      },
      autopay: {
        token: null,
        authorized_at: null,
        retries: 0,
        payment_reminder_days: 0,
        send_welcome: true,
        send_declined: true,
        send_overdue: true,
        send_authorization: false,
        send_invoice: false,
      },
      amounts: {
        total: 0,
        taxes: 0,
        fees: 0,
        discounts: 0,
        shipping: 0,
      },
      payment: {
        memo: null,
        enable_ach: true,
        enable_card: true,
      },
      emails: {
        ap_notification: {
          subject: null,
          link: null,
          body: null,
        },
        ap_authorization: {
          subject: null,
          link: null,
          body: null,
        },
        ap_reminder: {
          subject: null,
          link: null,
          body: null,
        },
        ap_declined: {
          subject: null,
          link: null,
          body: null,
        },
        ap_overdue: {
          subject: null,
          link: null,
          body: null,
        },
        ap_delinquent: {
          subject: null,
          link: null,
          body: null,
        },
        ap_request: {
          subject: null,
          link: null,
          body: null,
        },
        ap_retry: {
          subject: null,
          link: null,
          body: null,
        },

        invoice_notification: null,
        invoice_reminder: null,
        invoice_late: null,
        invoice_overdue: null,
        invoice_delinquent: null,
      },
      cart: {},
      customer_id: null,
      cart_id: null,
      meta_data: {},
      custom_fields: [],
      tags: [],
      notes: [],
      mid_id: null,
      settings_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (data.mid) {
      data.mid = new models.api.Mids(data.mid);
    }

    if (data.contact) {
      data.contact = new models.api.Contacts(data.contact);
    }

    if (data.company) {
      data.company = new models.api.Companies(data.company);
    }

    if (data.cart) {
      data.cart = new models.api.Carts(data.cart);
    }

    if (data.schedules && data.schedules.length > 0) {
      data.schedules.map(async (schedule) => {
        schedule = new models.api.Schedules(schedule);
      });
    }

    if (data.transactions && data.transactions.length > 0) {
      data.transactions.map(async (transaction) => {
        transaction = new models.api.Transactions(transaction);
      });
    }

    return data;
  }
}
